<template>
    <div>
        <div class="row mt-5 mb-4">
            <div class="col-12 text-center">
                <h1>Featured Work</h1>
                <hr class="header-underline">
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-right" data-aos-duration="1500">
                <img id="sitespring-preview" class="w-100" src="../assets/client-logos/previews/sitespring-screenshot.png" />
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-left" data-aos-duration="1500">
                <img id="sitespring-logo" class="pt-3 mb-lg-5 mb-4" src="../assets/client-logos/logos/sitespring-logo.png" />
                <h5 class="text-dark client-description"><b>Project Management</b></h5>
                <h5 class="text-dark client-description"><b>Custom PHP Software Development</b></h5>
                <h5 class="text-dark client-description"><b>CI/CD Implementation</b></h5>
                <h5 class="text-dark client-description"><b>Automation Script Development</b></h5>
                <h5 class="text-dark client-description"><b>Firebase</b></h5>
                <h5 class="text-dark client-description"><b>Amazon Web Services</b></h5>
                <h5 class="text-dark client-description"><b>Database Management and Configuration</b></h5>
                <h5 class="text-dark client-description"><b>API Design</b></h5>
                <h5 class="text-dark client-description"><b>Database Design</b></h5>
                <div class="row mt-5">
                    <div class="col-12 mt-1">
                        <a href="https://site-spring.com" target="_blank">
                            <h4>Visit Site</h4>
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="https://site-spring.com" target="_blank">
                            <div class="link-arrow mx-auto">
                                <img style="width: 1.4em; padding-top: 0.2em;" src="../assets/link-arrow.png" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <hr class="client-separator">

        <div class="row mt-5">
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3 hide-desktop" data-aos="fade-left" data-aos-duration="1500">
                <img id="mythical-preview" class="w-100" src="../assets/client-logos/previews/fbc-screenshot.png" />
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-right" data-aos-duration="1500">
                <img id="fbc-logo" class="pt-3 mb-lg-5 mb-4" src="../assets/client-logos/logos/fbc-logo.png" />
                <h5 class="text-dark client-description"><b>Project Management</b></h5>
                <h5 class="text-dark client-description"><b>PHP Development</b></h5>
                <h5 class="text-dark client-description"><b>VueJS Front-End Development</b></h5>
                <h5 class="text-dark client-description"><b>NodeJS Back-End Development</b></h5>
                <h5 class="text-dark client-description"><b>MySQL Database Management</b></h5>
                <h5 class="text-dark client-description"><b>CI/CD Implementation</b></h5>
                <h5 class="text-dark client-description"><b>Amazon Web Services</b></h5>
                <h5 class="text-dark client-description"><b>API Design</b></h5>
                <h5 class="text-dark client-description"><b>Third Party API Integrations</b></h5>
                <div class="row mt-5">
                    <div class="col-12 mt-1">
                        <a href="https://freedomboatclub.com" target="_blank">
                            <h4>Visit Site</h4>
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="https://freedomboatclub.com" target="_blank">
                            <div class="link-arrow mx-auto">
                                <img style="width: 1.4em; padding-top: 0.2em;" src="../assets/link-arrow.png" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3 hide-mobile" data-aos="fade-left" data-aos-duration="1500">
                <img id="mythical-preview" class="w-100" src="../assets/client-logos/previews/fbc-screenshot.png" />
            </div>
        </div>

        <hr class="client-separator">

        <div class="row mt-5">
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-right" data-aos-duration="1500">
                <img id="mythical-preview" class="w-100" src="../assets/client-logos/previews/mythical-screenshot.png" />
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-left" data-aos-duration="1500">
                <img id="mythical-logo" class="pt-3 pt-2 mb-lg-5 mb-4" src="../assets/client-logos/logos/mythical-logo.png" />
                <h5 class="text-dark client-description"><b>VueJS Development</b></h5>
                <h5 class="text-dark client-description"><b>Laravel Development</b></h5>
                <h5 class="text-dark client-description"><b>CodeIgniter Development</b></h5>
                <div class="row mt-5">
                    <div class="col-12 mt-1">
                        <a href="https://mythicaldev.com" target="_blank">
                            <h4>Visit Site</h4>
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="https://mythicaldev.com" target="_blank">
                            <div class="link-arrow mx-auto">
                                <img style="width: 1.4em; padding-top: 0.2em;" src="../assets/link-arrow.png" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <hr class="client-separator">

        <div class="row mt-5">
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3 hide-desktop" data-aos="fade-left" data-aos-duration="1500">
                <img id="christophers-preview" class="w-100" src="../assets/client-logos/previews/christophers-screenshot.png" />
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3" data-aos="fade-right" data-aos-duration="1500">
                <img id="christophers-logo" class="pt-3 pt-2 mb-lg-5 mb-4" src="../assets/client-logos/logos/christophers-logo.png" />
                <h5 class="text-dark client-description"><b>Web Design</b></h5>
                <h5 class="text-dark client-description"><b>Custom VueJS Development</b></h5>
                <h5 class="text-dark client-description"><b>Hosting Management</b></h5>
                <h5 class="text-dark client-description"><b>SEO</b></h5>
                <div class="row mt-5">
                    <div class="col-12 mt-1">
                        <a href="https://christopherswri.com" target="_blank">
                            <h4>Visit Site</h4>
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="https://christopherswri.com" target="_blank">
                            <div class="link-arrow mx-auto">
                                <img style="width: 1.4em; padding-top: 0.2em;" src="../assets/link-arrow.png" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 text-center p-0 m-lg-0 my-3 mx-3 hide-mobile" data-aos="fade-left" data-aos-duration="1500">
                <img id="christophers-preview" class="w-100" src="../assets/client-logos/previews/christophers-screenshot.png" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Clients'
    }
</script>